import './footer.component.scss';
import { useEffect, useState } from "react";

const Footer = () => {
  const footer = require("../../assets/dandilion-2025-full-logo.png");
  const [hasPosition, setHasPosition] = useState(false);

  const footerStyle = {
    color:'#787676'
  };
  const footerLogoStyle={
    height:'2em',
   
  }

  useEffect(() => {
    const checkPosition = () => {
      const elems = document.getElementsByClassName("feedback-bottom-con");
      setHasPosition(elems.length > 0);
    };

    // Initial check
    checkPosition();

    // Optional: if elements might be added later
    const observer = new MutationObserver(checkPosition);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const handleClick = () => {
    window.open("https://www.dandilion.ai/", "_blank");
  };

  return (
    <footer className='footer'>
      <p style={footerStyle} className={hasPosition ? "positionp" : ""}>
       <span className="footertext">Powered by</span> 
       <img  onClick={handleClick} style={footerLogoStyle} src={footer} className='img' alt="footer_img"></img> 
      </p>
    </footer>
  );
};

export default Footer;
